
export default function CruisesWidgit() {


  return (
<>
<script charSet="utf-8" src="//www.travelpayouts.com/widgets/97b99d9fd2e466cb3fd63f9f3c256bf8.js?v=2012" async></script>
<p className="mb-4 pb-0">Enjoy Your Summer Vacation with Cheap Flights Prices & Checkout our Hotel deals to make your summer vacations a memorable</p>


    </>
  );
}
